export default function getTeamLevel(state) {
  return state.getIn(['currentChapter', 'data', 'team_level'], 0);
}
